/**
 * create by zhengyongbo
 */

import testPage from "./testPage"
import userInfo from "./userInfo"
import authority from "./authority"

import permission from './permission'
import tagsView from "./tagsView"
import menu from "./menu"

const moduleStores={
    testPage,
    userInfo,
    authority,
    permission,
    tagsView,
    menu
}

export default moduleStores
